import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/ocean-smart-meter-backup-switch';
import { useGlobal } from '@/utils/useGlobal';
import Specs from '@elem/compPage/OceanSmartMeterBackupSwitch/Specs';
import dynamic from 'next/dynamic';

export default function Page({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();

    const { t } = useLang('OceanSmartMeterBackupSwitch');

    const router = useRouter();

    const { locale } = router;

    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    useEffect(() => {
        if (!seoconfig.include.includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop theme="black">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url + '/specs'} />
            <GtmPageLoad />
            <Specs />
        </PageLayout>
    );
}
